<template>
  <div id="app">
    <myaudio v-show="audio.audioshow"></myaudio>
    <router-view/>
  </div>
</template>

<script>
  import myaudio from '@/components/audio/audioTop'
  import { mapState } from 'vuex'
  export default {
    data(){
      return{
        audioTopIndexClass:false
      }
    },
    computed: mapState({
        audio: state => state.audio
      }
    ),
    mounted(){

    },
    components: {
      myaudio
    },
    name: 'App'
  }
</script>

<style>
  body{
    padding: 0;
    margin: 0;
  }
  html,body,#app {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: white;
    overflow-x: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue